export default function PostLoader() {
  return (
    <div className="grid grid-cols-3 my-10 gap-x-12 animate-pulse">
      <div className="col-span-3 lg:col-span-2 space-y-10">
        <div className="rounded-lg aspect-w-16 aspect-h-9 bg-gray-200" />

        <div className="space-y-2.5">
          <div className="h-4 bg-gray-200 rounded w-1/2" />
          <div className="h-3 bg-gray-200 rounded w-1/4" />
          <div className="h-2 bg-gray-200 rounded w-full" />
          <div className="h-2 bg-gray-200 rounded w-full" />
          <div className="h-2 bg-gray-200 rounded w-full" />
          <div className="h-2 bg-gray-200 rounded w-1/3" />
          <div className="h-2 bg-gray-200 rounded w-full" />
          <div className="h-2 bg-gray-200 rounded w-full" />
          <div className="h-2 bg-gray-200 rounded w-full" />
          <div className="h-2 bg-gray-200 rounded w-1/4" />
        </div>
      </div>

      <div className="hidden lg:block bg-gray-200 rounded-lg" />
    </div>
  );
}
